import { render, staticRenderFns } from "./DashboardV1.vue?vue&type=template&id=3b760ba8&scoped=true"
import script from "./DashboardV1.vue?vue&type=script&lang=js"
export * from "./DashboardV1.vue?vue&type=script&lang=js"
import style0 from "./DashboardV1.vue?vue&type=style&index=0&id=3b760ba8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b760ba8",
  null
  
)

export default component.exports